<template>
  <div class="main">

    <div class="instr_top">
      <ul>
        <li class="clearfix">
          <span>种类:</span>
          <a href="javascript:;" @click="instr_type(0)" :class="instr_type_id == 0 ? 'act' : ''">全部</a>
          <a href="javascript:;" @click="instr_type(item.id)" :class="instr_type_id == item.id ? 'act' : ''"
             v-for="(item,key) in typelist" :key="key" v-cloak>{{ item.name }}</a>
        </li>
        <li class="clearfix" v-if="instr_type_id != 0">
          <span>品牌:</span>
          <a href="javascript:;" @click="instr_case(0)" :class="instr_case_id == 0 ? 'act' : ''">全部</a>
          <a href="javascript:;" @click="instr_case(item)" :class="instr_case_id == item ? 'act' : ''"
             v-for="(item,key) in caselist" :key="key" v-cloak>{{ item }}</a>
        </li>
      </ul>

      <div class="add_instr">
        <button @click="addinstr()">添加设备指令</button>
        <button @click="handleSave_fk">反馈建议</button>
      </div>
    </div>

    <div class="instr_bottom">
      <div class="video_none" v-cloak v-if="!instructions_list.length">
        <img :src="img.none" alt=""/>
      </div>
      <ul class="clearfix">
        <li v-for="(item,key) in instructions_list" :key="key" @click="get_detail(item.id)">
          <div class="img">
            <img :src="item.cover == '' ? img.noneimg : item.cover" alt="">
          </div>
          <div class="nr">
            <p v-cloak>{{ item.model }}</p>
            <div><span v-cloak>种类 - {{ item.product_name }}</span> | <span v-cloak>品牌 - {{ item.brand }}</span></div>
          </div>
        </li>
      </ul>
    </div>
    <loading v-if="isloading"></loading>
    <!-- 页码区 -->
    <div v-if="total > 20" class="page">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="pager"
        :page-size="20"
        :total="total"
      >
      </el-pagination>
    </div>
    <div v-else class="page"></div>

    <div class="add_instr_box">
      <el-dialog title="设备指令添加" :visible.sync="dialogFormVisible" @closed="handleClose" width="584px"
                 :close-on-click-modal="false">

        <div class="form_top">
          <div class="form_top_left">
            <ul>
              <li>
                <span class="bt">设备种类</span>
                <el-select v-model="add_form.product_id" placeholder="请选择" @change="handleSelect(add_form.product_id)">
                  <el-option
                    v-for="item in typelist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>

              </li>
              <li>
                <span class="bt">设备品牌</span>
                <!-- <el-input v-model="add_form.brand" autocomplete="off"></el-input> -->
                <!-- filterable allow-create default-first-option clearable -->

                <el-select v-model="add_form.brand" placeholder="请选择或输入">
                  <el-option v-for="item in caselist1" :key="item" :label="item" :value="item"></el-option>
                </el-select>

              </li>
              <li>
                <span class="bt">设备型号</span>
                <el-input v-model="add_form.model" autocomplete="off"></el-input>
              </li>
              <li>
                <span class="bt">设备协议</span>
                <el-checkbox-group v-model="protocol">
                  <el-checkbox v-model="protocol" v-for="date in check_dates" :label="date.key" :key="date.key"
                               @change="handleCheckAllChange">{{ date.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </li>
            </ul>
          </div>
          <div class="form_top_right">
            <div class="">
              <el-upload
                class="avatar-uploader"
                :action="uploadurl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-error="handleAvatarError"
                :before-upload="beforeAvatarUpload"
                :data="datalist"
              >
                <img v-if="add_form.cover" :src="add_form.cover" class="avatar"/>

                <div v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <span>设备图片上传</span>
                  <p>(图片大小在200k以下进行上传)</p>
                </div>
              </el-upload>
            </div>
          </div>
        </div>

        <div class="form_center">
          <span>设备指令输入</span>
          <span>如需使用投影机控制功能，请使用预设的指令名</span>
        </div>

        <div class="form_tcp_bottom" v-if="is_tcp">
          <h5>TCP</h5>
          <div class="dkh">
            <span class="bt">端口号</span>
            <el-input v-model="add_form.tcp_port" autocomplete="off"></el-input>
          </div>
          <ul>
            <li>
              <div class="zlm">
                <span>指令名</span>
              </div>
              <div class="zlnr">
                <span>指令内容</span>
              </div>
            </li>
            <li v-for="(item,key) in tcp_command" :key="key">
              <i class="el-icon-delete" @click="del_command(1,key)"></i>
              <div class="zlm">
                <el-input v-model="item.name" autocomplete="off"></el-input>
              </div>
              <div class="zlnr">
                <el-input v-model="item.content" autocomplete="off"></el-input>
              </div>
            </li>
          </ul>
          <div class="add_zhiling">
            <span @click="add_zhiling(1)">添加1条指令</span>
            <span @click="add_zhiling1(1)">添加5条指令</span>
          </div>
        </div>

        <div class="form_tcp_bottom" v-if="is_udp">
          <h5>UDP</h5>
          <div class="dkh">
            <span class="bt">端口号</span>
            <el-input v-model="add_form.udp_port" autocomplete="off"></el-input>
          </div>
          <ul>
            <li>
              <div class="zlm">
                <span>指令名</span>
              </div>
              <div class="zlnr">
                <span>指令内容</span>
              </div>
            </li>
            <li v-for="(item,key) in udp_command" :key="key">
              <i class="el-icon-delete" @click="del_command(2,key)"></i>
              <div class="zlm">
                <el-input v-model="item.name" autocomplete="off"></el-input>
              </div>
              <div class="zlnr">
                <el-input v-model="item.content" autocomplete="off"></el-input>
              </div>
            </li>
          </ul>
          <div class="add_zhiling">
            <span @click="add_zhiling(2)">添加指令</span>
            <span @click="add_zhiling1(2)">添加5条指令</span>
          </div>
        </div>

        <div class="form_tcp_bottom" v-if="is_ck">
          <h5>串口</h5>
          <div class="ck_ul">
            <div class="ck_list">
              <span class="bt">波特率</span>

              <el-select v-model="add_form.baud_rate" placeholder="选择">
                <el-option key="4800" label="4800" value="4800"></el-option>
                <el-option key="9600" label="9600" value="9600"></el-option>
                <el-option key="19200" label="19200" value="19200"></el-option>
                <el-option key="57600" label="57600" value="57600"></el-option>
                <el-option key="115200" label="115200" value="115200"></el-option>
                <el-option key="256000" label="256000" value="256000"></el-option>
                <el-option key="921600" label="921600" value="921600"></el-option>
              </el-select>


            </div>
            <div class="ck_list">
              <span class="bt">校验位</span>
              <el-select v-model="add_form.check_bit" placeholder="选择">
                <el-option key="无" label="无" value="无"></el-option>
                <el-option key="奇" label="奇" value="奇"></el-option>
                <el-option key="偶" label="偶" value="偶"></el-option>
              </el-select>
              <!-- 无 -->
            </div>
            <div class="ck_list">
              <span class="bt">数据位</span>
              <el-select v-model="add_form.data_bit" placeholder="选择">
                <el-option key="5" label="5" value="5"></el-option>
                <el-option key="6" label="6" value="6"></el-option>
                <el-option key="7" label="7" value="7"></el-option>
                <el-option key="8" label="8" value="8"></el-option>
              </el-select>
              <!-- 8 -->
            </div>
            <div class="ck_list">
              <span class="bt">停止位</span>
              <el-select v-model="add_form.stop_bit" placeholder="选择">
                <el-option key="1" label="1" value="1"></el-option>
                <el-option key="1.5" label="1.5" value="1.5"></el-option>
                <el-option key="2" label="2" value="2"></el-option>

              </el-select>
              <!-- 1 -->
            </div>
          </div>
          <div class="ck_str">
            <el-radio v-model="add_form.is_hex" label="0">字符串</el-radio>
            <el-radio v-model="add_form.is_hex" label="1">十六进制</el-radio>
            <span style="color: red;" v-if="add_form.is_hex == 1">请键入一个美元符号$后跟两个十六进制数字，如$00</span>
          </div>
          <ul>
            <li>
              <div class="zlm">
                <span>指令名</span>
              </div>
              <div class="zlnr">
                <span>指令内容</span>
              </div>
            </li>
            <li v-for="(item,key) in ck_command" :key="key">
              <i class="el-icon-delete" @click="del_command(3,key)"></i>
              <div class="zlm">
                <el-input v-model="item.name" autocomplete="off"></el-input>
              </div>
              <div class="zlnr">
                <el-input v-model="item.content" autocomplete="off"></el-input>
              </div>
            </li>
          </ul>
          <div class="add_zhiling">
            <span @click="add_zhiling(3)">添加指令</span>
            <span @click="add_zhiling1(3)">添加5条指令</span>
          </div>
        </div>


        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="detail_instr_box">
      <el-dialog title="设备信息" :visible.sync="dialogFormVisible1" @closed="handleClose" width="584px"
                 :close-on-click-modal="false">

        <div class="form_top">
          <div class="form_top_left">
            <ul>
              <li>
                <span class="bt">设备种类</span>
                <p v-text="detail_form.product_name"></p>

              </li>
              <li>
                <span class="bt">设备品牌</span>
                <p v-text="detail_form.brand"></p>
              </li>
              <li>
                <span class="bt">设备型号</span>
                <p v-text="detail_form.model"></p>
              </li>
              <li>
                <span class="bt">设备协议</span>
                <p v-text="detail_form.protocol"></p>
              </li>
            </ul>
          </div>
          <div class="form_top_right">
            <div class="">
              <img v-if="detail_form.cover" :src="detail_form.cover" class="avatar"/>
            </div>
          </div>
        </div>

        <div class="form_center">
          <p>设备指令输入</p>
        </div>
        <div class="form_bottom">
          <ul>
            <li v-if="tcp_detail">
              <h4>TCP</h4>
              <div class="top">
                <span>设备端口号:</span>
                <p v-text="detail_form.tcp_port"></p>
              </div>
              <div class="bottom">
                <h4>支持指令</h4>
                <p v-for="item in detail_form.command" v-if="item.protocol == 1">{{ item.name }}</p>
              </div>
            </li>
            <li v-if="udp_detail">
              <h4>UDP</h4>
              <div class="top">
                <span>设备端口号:</span>
                <p v-text="detail_form.udp_port"></p>
              </div>
              <div class="bottom">
                <h4>支持指令</h4>
                <p v-for="item in detail_form.command" v-if="item.protocol == 2">{{ item.name }}</p>
              </div>
            </li>
            <li v-if="ck_detail">
              <h4>串口</h4>
              <div class="top">
                <div>
                  <span>波特率:</span>
                  <p v-text="detail_form.baud_rate"></p>
                </div>
                <div>
                  <span>校验位:</span>
                  <p v-text="detail_form.check_bit"></p>
                </div>
                <div>
                  <span>数据位:</span>
                  <p v-text="detail_form.data_bit"></p>
                </div>
                <div>
                  <span>停止位:</span>
                  <p v-text="detail_form.stop_bit"></p>
                </div>
              </div>
              <div class="bottom">
                <h4>支持指令</h4>
                <p v-for="item in detail_form.command" v-if="item.protocol == 3">{{ item.name }}</p>
              </div>
            </li>
          </ul>
        </div>


        <div slot="footer" class="dialog-footer">
          <el-button @click="handleSave_bc">内容补充</el-button>
          <el-button @click="handleSave_fk">问题反馈</el-button>
          <el-button @click="handleSave_xz">文件下载</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="add_instr_box append_instr_box">
      <el-dialog title="内容补充" :visible.sync="dialogFormVisible2" @closed="handleClose" width="584px"
                 :close-on-click-modal="false">

        <div class="append_top">
          <p>请选择指令使用的协议</p>
          <el-checkbox-group v-model="protocol">
            <el-checkbox v-model="protocol" v-for="date in check_dates" :label="date.key" :key="date.key"
                         @change="handleCheckAllChange">{{ date.label }}
            </el-checkbox>
          </el-checkbox-group>
          <p>请补充缺少的的协议</p>
        </div>

        <div class="form_tcp_bottom" v-if="is_tcp">
          <h5>TCP</h5>
          <div class="dkh">
            <span class="bt">端口号</span>
            <el-input v-model="detail_form.tcp_port == '' ? '2000' : detail_form.tcp_port" autocomplete="off"
                      disabled></el-input>
          </div>
          <ul>
            <li>
              <div class="zlm">
                <span>指令名</span>
              </div>
              <div class="zlnr">
                <span>指令内容</span>
              </div>
            </li>
            <li v-for="(item,key) in tcp_command" :key="key">
              <i class="el-icon-delete" @click="del_command(1,key)"></i>
              <div class="zlm">
                <el-input v-model="item.name" autocomplete="off"></el-input>
              </div>
              <div class="zlnr">
                <el-input v-model="item.content" autocomplete="off"></el-input>
              </div>
            </li>
          </ul>
          <div class="add_zhiling">
            <span @click="add_zhiling(1)">添加指令</span>
            <span @click="add_zhiling1(1)">添加5条指令</span>
          </div>
        </div>

        <div class="form_tcp_bottom" v-if="is_udp">
          <h5>UDP</h5>
          <div class="dkh">
            <span class="bt">端口号</span>
            <el-input v-model="detail_form.udp_port == '' ? '2000' : detail_form.udp_port" autocomplete="off"
                      disabled></el-input>
          </div>
          <ul>
            <li>
              <div class="zlm">
                <span>指令名</span>
              </div>
              <div class="zlnr">
                <span>指令内容</span>
              </div>
            </li>
            <li v-for="(item,key) in udp_command" :key="key">
              <i class="el-icon-delete" @click="del_command(2,key)"></i>
              <div class="zlm">
                <el-input v-model="item.name" autocomplete="off"></el-input>
              </div>
              <div class="zlnr">
                <el-input v-model="item.content" autocomplete="off"></el-input>
              </div>
            </li>
          </ul>
          <div class="add_zhiling">
            <span @click="add_zhiling(2)">添加指令</span>
            <span @click="add_zhiling1(2)">添加5条指令</span>
          </div>
        </div>

        <div class="form_tcp_bottom" v-if="is_ck">
          <h5>串口</h5>
          <div class="ck_ul">
            <div class="ck_list">
              <span class="bt">波特率</span>
              <el-input v-model="detail_form.baud_rate == '' ? '115200' : detail_form.baud_rate " autocomplete="off"
                        disabled></el-input>
            </div>
            <div class="ck_list">
              <span class="bt">校验位</span>
              <el-input v-model="detail_form.check_bit == '' ? '无' : detail_form.check_bit" autocomplete="off"
                        disabled></el-input>
            </div>
            <div class="ck_list">
              <span class="bt">数据位</span>
              <el-input v-model="detail_form.data_bit == '' ? '8' : detail_form.data_bit" autocomplete="off"
                        disabled></el-input>
            </div>
            <div class="ck_list">
              <span class="bt">停止位</span>
              <el-input v-model="detail_form.stop_bit == '' ? '1' : detail_form.stop_bit" autocomplete="off"
                        disabled></el-input>
            </div>
          </div>
          <div class="ck_str">
            <el-radio v-model="detail_form.is_hex" label="0">字符串</el-radio>
            <el-radio v-model="detail_form.is_hex" label="1">十六进制</el-radio>
            <span style="color: red;" v-if="detail_form.is_hex == 1">请键入一个美元符号$后跟两个十六进制数字，如$00</span>
          </div>
          <ul>
            <li>
              <div class="zlm">
                <span>指令名</span>
              </div>
              <div class="zlnr">
                <span>指令内容</span>
              </div>
            </li>
            <li v-for="(item,key) in ck_command" :key="key">
              <i class="el-icon-delete" @click="del_command(3,key)"></i>
              <div class="zlm">
                <el-input v-model="item.name" autocomplete="off"></el-input>
              </div>
              <div class="zlnr">
                <el-input v-model="item.content" autocomplete="off"></el-input>
              </div>
            </li>
          </ul>
          <div class="add_zhiling">
            <span @click="add_zhiling(3)">添加指令</span>
            <span @click="add_zhiling1(3)">添加5条指令</span>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="handleSave_append_save">添加</el-button>
        </div>
      </el-dialog>
    </div>


    <div class="fankui_instr_box">
      <el-dialog title="问题反馈" :visible.sync="dialogFormVisible3" @closed="handleClose" width="450px"
                 :close-on-click-modal="false">
        <h4>您的邮箱</h4>
        <el-input v-model="email" autocomplete="off" placeholder="请输入邮箱"></el-input>
        <h4>请描述您遇到的问题</h4>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea">
        </el-input>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible3 = false">取 消</el-button>
          <el-button type="primary" @click="handleSave_fk_save">确 定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import loading from "./../../widget/loading";
import uploadOss from "@/utils/uploadOss";
import {Message} from "element-ui";

export default {
  components: {
    loading,
  },
  data() {
    return {
      is_tcp: false,
      is_udp: false,
      is_ck: false,
      radio: 1,
      add_form: {
        product_id: '', //设备种类
        brand: '', //设备品牌
        model: '', //设备型号
        cover: '', //设备图片
        protocol: '', //设备协议
        tcp_port: '',  //tcp端口号
        udp_port: '',  //udp端口号
        baud_rate: '115200', //串口波特率
        check_bit: '无', //串口校验位
        stop_bit: '1', //串口停止位
        data_bit: '8', //串口数据位
        is_hex: '0',   //内容类型 0=字符串，1=十六进制
        command: [] //命令
      },

      tcp_command: [{name: '', content: '', protocol: 1}],
      udp_command: [{name: '', content: '', protocol: 2}],
      ck_command: [{name: '', content: '', protocol: 3}],

      protocol: [],

      tcp_detail: false,
      udp_detail: false,
      ck_detail: false,
      // 复选
      check_dates: [
        {key: 1, label: 'TCP'},
        {key: 2, label: 'UDP'},
        {key: 3, label: '串口'}
      ],

      dialogFormVisible: false, // 新增弹出
      dialogFormVisible1: false, //详情弹出
      dialogFormVisible2: false, //内容补充弹出
      dialogFormVisible3: false, //反馈弹出

      isloading: true,
      showInput: false,
      // 指令选择
      typelist: [],
      caselist: [],
      caselist1: [],
      instr_type_id: 0,
      instr_case_id: 0,
      instr_case_brand: '',
      // 指令列表
      instructions_list: [],
      // 分页
      total: 40,
      currentPage: 1,

      // 上传
      imageUrl: "",
      uploadurl: "",
      domain: "",
      datalist: {},
      key: '',

      // 详情
      detail_form: {},
      // 反馈内容
      textarea: '',
      email: '',
      keywork: '',
    };
  },
  methods: {

    // 获取设备分类
    command_device_category() {
      this.$store
        .dispatch("post", {url: "command_device_category",})
        .then((res) => {
          if (res) {
            this.typelist = res.data
          }
        });
    },

    // 种类点击
    instr_type(id) {
      this.instr_type_id = id
      this.instr_case_brand = ''
      this.instr_case_id = 0

      this.currentPage =  1

      this.getinstructions_list()

      this.typelist.map((item, key) => {
        if (item.id == id) {
          console.log(item.brand)
          this.caselist = item.brand.split(',')
        }
      })
      console.log(this.caselist)

    },
    // 添加时选择种类
    handleSelect(itemid) {
      var id = itemid
      this.add_form.brand = ''
      this.caselist1 = []
      this.typelist.map((item, key) => {
        if (item.id == id) {
          console.log(item.brand)
          this.caselist1 = item.brand.split(',')
        }
      })

    },
    // 品牌点击
    instr_case(item) {
      this.instr_case_brand = item
      if (item.id) {
        this.instr_case_id = item
      } else {
        this.instr_case_id = item
      }
      this.getinstructions_list()
    },

    // 获取设备库列表
    getinstructions_list() {
      var data = {
        product_id: this.instr_type_id,
        brand: this.instr_case_brand,
        page: this.currentPage,
        keyword: this.keywork,
      }
      this.$store
        .dispatch("post", {url: "command_list", data: data})
        .then((res) => {
          if (res) {
            this.isloading = false;
            this.total = Number(res.data.count)
            this.instructions_list = res.data.list
          }
        });
    },

    // 分页
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getinstructions_list();
    },

    // 添加设备指令
    addinstr() {
      console.log(this.isLogin())
      if (this.isLogin()) {
        this.dialogFormVisible = true
      } else {
        this.$store.commit("changeQrcode", true);
      }
    },

    // 选择设备协议
    handleCheckAllChange(val) {
      // console.log(this.add_form.checkList)
      // console.log(this.add_form.checkList.indexOf(1))
      if (this.protocol.includes(1)) {
        this.is_tcp = true
      } else {
        this.is_tcp = false
      }
      if (this.protocol.includes(2)) {
        this.is_udp = true
      } else {
        this.is_udp = false
      }
      if (this.protocol.includes(3)) {
        this.is_ck = true
      } else {
        this.is_ck = false
      }
    },
    // 删除对应的命令
    del_command(type, key) {
      if (type == 1) {
        this.tcp_command.splice(key, 1)
      } else if (type == 2) {
        this.udp_command.splice(key, 1)
      } else if (type == 3) {
        this.ck_command.splice(key, 1)
      }
    },
    //   上传成功
    handleAvatarSuccess(res, file) {
      console.log(file)
      if (res.Status == "Ok") {
        Message.success("上传成功");
        this.imageUrl = URL.createObjectURL(file.raw);
        this.add_form.cover = this.domain + this.datalist.key
        console.log(this.domain + this.datalist.key)
      }
    },
    // 上传失败
    handleAvatarError(res, file) {
      Message.error("上传失败, 请重新上传");
    },
    get_suffix(filename) {
      var pos = filename.lastIndexOf(".");
      var suffix = "";
      if (pos != -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    random_string(len) {
      var len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      // const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        Message.error("上传照片只能是 JPG, PNG 格式!");
      }
      if (!isLt2M) {
        Message.error("上传照片大小不能超过 2MB!");
      }
      let key = this.key + this.random_string(20) + this.get_suffix(file.name)
      this.datalist.key = key;
      console.log(this.key)
      return isJPG && isLt2M;
    },

    handleClose() {
      this.add_form = {
        product_id: '', //设备种类
        brand: '', //设备品牌
        model: '', //设备型号
        cover: '', //设备图片
        protocol: '', //设备协议
        uid: '',
        source_token: '',
        tcp_port: '',  //tcp端口号
        udp_port: '',  //udp端口号
        baud_rate: '115200', //串口波特率
        check_bit: '无', //串口校验位
        stop_bit: '1', //串口停止位
        data_bit: '8', //串口数据位
        is_hex: '0',   //内容类型 0=字符串，1=十六进制
        command: [] //命令

      }
      this.protocol = []
      this.tcp_command = [{name: '', content: '', protocol: 1}]
      this.udp_command = [{name: '', content: '', protocol: 2}]
      this.ck_command = [{name: '', content: '', protocol: 3}]
      this.is_tcp = false
      this.is_udp = false
      this.is_ck = false
      if (this.dialogFormVisible1 == false) {
        this.tcp_detail = false
        this.udp_detail = false
        this.ck_detail = false
      }

      // 反馈建议
      this.textarea = ''
    },
    // 确认保存
    handleSave() {


      if (this.add_form.product_id == '') {
        Message.error('请选择设备种类');
        return false
      }
      if (this.add_form.brand == '') {
        Message.error('请输入设备品牌');
        return false
      }
      if (this.add_form.model == '') {
        Message.error('请输入设备型号');
        return false
      }
      // if(this.add_form.cover == ''){
      //   Message.error('请上传设备图片');
      //   return false
      // }
      if (this.protocol.length == 0) {
        Message.error('请选择设备协议');
        return false
      }
      if (this.is_tcp == true) {
        if (this.add_form.tcp_port == '') {
          Message.error('请输入TCP端口号');
          return false
        }
      }
      if (this.is_udp == true) {
        if (this.add_form.udp_port == '') {
          Message.error('请输入UDP端口号');
          return false
        }
      }
      if (this.is_ck == true) {
        if (this.add_form.baud_rate == '') {
          Message.error('请输入串口波特率');
          return false
        }
        if (this.add_form.check_bit == '') {
          Message.error('请输入串口校验位');
          return false
        }
        if (this.add_form.stop_bit == '') {
          Message.error('请输入串口停止位');
          return false
        }
        if (this.add_form.data_bit == '') {
          Message.error('请输入串口数据位');
          return false
        }
        if (this.add_form.is_hex == '') {
          Message.error('请选择串口内容类型');
          return false
        }
      } else {
        this.add_form.baud_rate = ''
        this.add_form.check_bit = ''
        this.add_form.stop_bit = ''
        this.add_form.data_bit = ''
      }


      var arr_command1 = []
      var arr_command2 = []
      var arr_command3 = []
      let answerBol1 = true;
      let answerBol2 = true;
      let answerBol3 = true;
      if (this.is_tcp == true) {

        this.tcp_command.map((item, key) => {
          if (answerBol1 == true) {
            if (item.name != '' && item.content == '') {
              Message.error('请输入TCP指令内容');
              answerBol1 = false
              return answerBol1
            } else if (item.name == '' && item.content != '') {
              Message.error('请输入TCP指令名');
              answerBol1 = false
              return answerBol1
            } else {
              arr_command1.push(item)
            }
          }
        })
        if (answerBol1) {

        } else {
          return false
        }
      }
      if (this.is_udp == true) {
        this.udp_command.map((item, key) => {
          if (answerBol2 == true) {
            if (item.name != '' && item.content == '') {
              Message.error('请输入UDP指令内容');
              answerBol2 = false
              return answerBol2
            } else if (item.name == '' && item.content != '') {
              Message.error('请输入UDP指令名');
              answerBol2 = false
              return answerBol2
            } else {
              arr_command2.push(item)
            }
          }
        })
        if (answerBol2) {

        } else {
          return false
        }
      }
      if (this.is_ck == true) {
        this.ck_command.map((item, key) => {
          if (answerBol3 == true) {
            if (item.name != '' && item.content == '') {
              Message.error('请输入串口指令内容');
              answerBol3 = false
              return answerBol3
            } else if (item.name == '' && item.content != '') {
              Message.error('请输入串口指令名');
              answerBol3 = false
              return answerBol3
            } else {
              arr_command3.push(item)
            }
          }
        })
        if (answerBol3) {

        } else {
          return false
        }
      }

      this.add_form.command = arr_command1.concat(arr_command2).concat(arr_command3)
      this.add_form.command = JSON.stringify(this.add_form.command)

      this.protocol.map((item, key) => {
        if (item == 1) {
          this.protocol.splice(key, 1, 'TCP')
        }
        if (item == 2) {
          this.protocol.splice(key, 1, 'UDP')
        }
        if (item == 3) {
          this.protocol.splice(key, 1, '串口')
        }
      })

      this.add_form.protocol = this.protocol.toString()


      this.$store
        .dispatch("post", {url: "command_add", data: this.add_form})
        .then((res) => {
          if (res) {
            Message.success(res.msg);
            this.dialogFormVisible = false

          }
        });


    },

    // 添加指令
    add_zhiling(type) {
      if (type == 1) {
        this.tcp_command.push({name: '', content: '', protocol: 1})
      } else if (type == 2) {
        this.udp_command.push({name: '', content: '', protocol: 2})
      } else if (type == 3) {
        this.ck_command.push({name: '', content: '', protocol: 3})
      }

    },
    add_zhiling1(type) {
      if (type == 1) {
        for (var i = 0; i < 5; i++) {
          this.tcp_command.push({name: '', content: '', protocol: 1})
        }
      } else if (type == 2) {
        for (var i = 0; i < 5; i++) {
          this.udp_command.push({name: '', content: '', protocol: 2})
        }
      } else if (type == 3) {
        for (var i = 0; i < 5; i++) {
          this.ck_command.push({name: '', content: '', protocol: 3})
        }
      }

    },
    // 获取查看详情
    get_detail(id) {
      var data = {id: id}
      this.$store
        .dispatch("post", {url: "command_detail", data: data})
        .then((res) => {
          if (res) {
            this.detail_form = res.data

            var product_name = ''
            this.typelist.map((item, key) => {
              if (item.id == this.detail_form.product_id) {
                this.detail_form.product_name = item.name
              }
            })


            if (res.data.protocol.indexOf('TCP') != -1) {
              this.tcp_detail = true
            }
            if (res.data.protocol.indexOf('UDP') != -1) {
              this.udp_detail = true
            }
            if (res.data.protocol.indexOf('串口') != -1) {
              this.ck_detail = true
            }


            this.dialogFormVisible1 = true
          }
        });

    },
    // 内容补充
    handleSave_bc() {

      if (this.isLogin()) {
        this.dialogFormVisible2 = true
      } else {
        this.$store.commit("changeQrcode", true);
      }

    },
    // 错误反馈
    handleSave_fk() {
      if (this.isLogin()) {
        this.dialogFormVisible3 = true
      } else {
        this.$store.commit("changeQrcode", true);
      }
    },
    // 文件下载
    handleSave_xz() {

      if (this.isLogin()) {
        var data = this.detail_form
        var tcp_command = []
        var tcp_json = {}
        var udp_command = []
        var udp_json = {}
        var serial_command = []
        var serial_json = {}
        data.command.map((item, key) => {
          if (item.protocol == 1) {
            tcp_json.name = item.name
            tcp_json.content = item.content
            tcp_command.push(JSON.parse(JSON.stringify(tcp_json)))
          }
          if (item.protocol == 2) {
            udp_json.name = item.name
            udp_json.content = item.content
            udp_command.push(JSON.parse(JSON.stringify(udp_json)))
          }
          if (item.protocol == 3) {
            serial_json.name = item.name
            serial_json.content = item.content
            serial_command.push(JSON.parse(JSON.stringify(serial_json)))
          }
        })
        var product_name = ''
        this.typelist.map((item, key) => {
          if (item.id == data.product_id) {
            product_name = item.name
          }
        })
        var detail = {
          model: data.model,
          product_name: product_name,
          protocol: data.protocol,
          stop_bit: data.stop_bit,
          tcp_port: data.tcp_port,
          udp_port: data.udp_port,
          is_hex: data.is_hex,
          data_bit: data.data_bit,
          cover: data.cover,
          baud_rate: data.baud_rate,
          brand: data.brand,
          check_bit: data.check_bit,
          tcp_command: JSON.parse(JSON.stringify(tcp_command)),
          udp_command: JSON.parse(JSON.stringify(udp_command)),
          serial_command: JSON.parse(JSON.stringify(serial_command))
        }
        var text_title = detail.product_name + '_' + detail.model;
        detail = JSON.stringify(detail)
        let str = new Blob([detail], {type: 'text/plain;charset=utf-8'});
        // 下载统计
        var parseid = {id: data.id}
        this.$store.dispatch("post", {url: "command_download", data: parseid}).then((res) => {
          if (res.status == 0) {
            // 注意这里要手动写上文件的后缀名
            saveAs(str, `${text_title}.json`);
          }
        });
      } else {
        this.$store.commit("changeQrcode", true);
      }

    },

    // 内容补充提交
    handleSave_append_save() {
      if (this.protocol.length == 0) {
        Message.error('请选择设备协议');
        return false
      }


      var arr_command1 = []
      var arr_command2 = []
      var arr_command3 = []
      let answerBol1 = true;
      let answerBol2 = true;
      let answerBol3 = true;
      if (this.is_tcp == true) {

        this.tcp_command.map((item, key) => {
          if (answerBol1 == true) {
            if (item.name != '' && item.content == '') {
              Message.error('请输入TCP指令内容');
              answerBol1 = false
              return answerBol1
            } else if (item.name == '' && item.content != '') {
              Message.error('请输入TCP指令名');
              answerBol1 = false
              return answerBol1
            } else {
              arr_command1.push(item)
            }
          }
        })
        if (answerBol1) {

        } else {
          return false
        }
      }
      if (this.is_udp == true) {
        this.udp_command.map((item, key) => {
          if (answerBol2 == true) {
            if (item.name != '' && item.content == '') {
              Message.error('请输入UDP指令内容');
              answerBol2 = false
              return answerBol2
            } else if (item.name == '' && item.content != '') {
              Message.error('请输入UDP指令名');
              answerBol2 = false
              return answerBol2
            } else {
              arr_command2.push(item)
            }
          }
        })
        if (answerBol2) {

        } else {
          return false
        }
      }
      if (this.is_ck == true) {
        this.ck_command.map((item, key) => {
          if (answerBol3 == true) {
            if (item.name != '' && item.content == '') {
              Message.error('请输入串口指令内容');
              answerBol3 = false
              return answerBol3
            } else if (item.name == '' && item.content != '') {
              Message.error('请输入串口指令名');
              answerBol3 = false
              return answerBol3
            } else {
              arr_command3.push(item)
            }
          }
        })
        if (answerBol3) {

        } else {
          return false
        }
      }

      this.add_form.command = arr_command1.concat(arr_command2).concat(arr_command3)
      this.add_form.command = JSON.stringify(this.add_form.command)
      var data = {
        device_id: this.detail_form.id,
        command: this.add_form.command
      }

      // console.log(data)
      // return false
      this.$store
        .dispatch("post", {url: "command_append", data: data})
        .then((res) => {
          if (res) {
            Message.success(res.msg);
            this.dialogFormVisible2 = false
          }
        });
    },

    // 反馈提交
    handleSave_fk_save() {
      console.log(this.detail_form)
      var data = {
        device_id: this.detail_form.id,
        content: this.textarea,
        email: this.email
      }
      if (data.content == '') {
        Message.error('请输入您要反馈的问题');
        return false
      }
      if (data.email != '') {
        var patt = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
        if (data.email.match(patt) == null) {
          Message.error('请输入正确的邮箱');
          return false
        }
      }

      this.$store
        .dispatch("post", {url: "command_feedback", data: data})
        .then((res) => {
          if (res) {
            Message.success(res.msg);
            this.dialogFormVisible3 = false
          }
        });
    },


  },
  created() {

  },
  mounted() {
    // 获取种类
    this.command_device_category()
    // 获取全部设备指令列表
    this.getinstructions_list()
    uploadOss.getData().then((res) => {
      this.key = res.formData.key
      this.domain = res.domain;
      this.datalist = res.formData;
      this.uploadurl = res.url;
    });
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        // console.log(oldVal)
        if (val.query.keywork != oldVal.query.keywork) {
          this.keywork = val.query.keywork
          this.getinstructions_list()
          // console.log(val.query.keywork);
          return false
        }

      }
    }
  }
};
</script>

<style lang="less">
.instr_top {
  width: 1300px;
  margin: 0 auto;
  position: relative;
  padding: 28px 32px 28px 32px;
  font-size: 14px;
  border-radius: 10px;
  background-color: #ffffff;
}

.instr_top ul {
  width: 100%;
  padding-right: 240px;
  box-sizing: border-box;
}

.instr_top ul li {
  width: 100%;
  line-height: 14px;
  margin-bottom: 18px;
}

.instr_top ul li span {
  display: inline-block;
  width: 42px;
  font-size: 14px;
  color: #333;
  float: left;
  -moz-text-align-last: justify;
  text-align-last: justify;
  line-height: 14px;
}

.instr_top ul li a {
  cursor: pointer;
  float: left;
  margin-left: 32px;
  font-size: 14px;
  line-height: 14px;
  color: #333333;
}

.instr_top ul li .act {
  color: #1783FF;
}

.add_instr {
  position: absolute;
  width: 225px;
  height: 26px;
  bottom: 20px;
  right: 26px;
}

.add_instr button {
  font-size: 14px;
  color: #fff;
  background: #1783FF;
  display: block;
  width: 105px;
  height: 26px;
  line-height: 26px;
  border-radius: 3px;
  float: left;
}

.add_instr button:nth-of-type(1) {
  margin-right: 15px;
}

.instr_bottom {
  width: 1300px;
  margin: 0 auto;
}

.instr_bottom ul li {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 10px;
  position: relative;
  width: calc((100% - 75px) / 4);
  margin-top: 20px;
  margin-bottom: 5px;
  margin-right: 25px;
  overflow: hidden;
  float: left;
}

.instr_bottom ul li:nth-of-type(4n) {
  margin-right: 0;
}

.instr_bottom ul li .img {
  width: 100%;
  height: 218px;
  overflow: hidden;
}

.instr_bottom ul li .img img {
  display: block;
  width: 100%;
  height: 218px;
  object-fit: cover;
}

.instr_bottom ul li .nr {
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  height: 64px;
}

.instr_bottom ul li .nr p {
  font-size: 15px;
  line-height: 16px;
  color: #333;
  height: 16px;
  overflow: hidden;
  margin-bottom: 10px;
  font-weight: bold;
}

.instr_bottom ul li .nr span {
  max-width: 40%;
  overflow: hidden;
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  line-height: 15px;
  height: 15px;
  overflow: hidden;
  display: inline-block;
  margin: 0 5px;
}

.instr_bottom ul li .nr div {
  line-height: 15px;
  height: 15px;
  overflow: hidden;
  font-size: 14px;
  color: #666;
}

.instr_bottom ul li .nr span:nth-of-type(1) {
  margin-left: 0;
}

// 添加弹出
.el-dialog__title {
  font-weight: bold;
}

.add_instr_box {
  width: ;
  font-size: 14px;
}

.add_instr_box .el-dialog__body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  height: 600px;
  overflow-y: scroll;
}

.add_instr_box .form_top {
  width: 100%;
  display: flex;
  padding: 10px 35px;
  box-sizing: border-box;
  justify-content: space-between;
}

.add_instr_box .form_top .form_top_left {
  width: 280px;
}

.add_instr_box .form_top .form_top_left ul li {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  line-height: 26px;
}

.add_instr_box .form_top .form_top_left ul li span.bt {
  width: 64px;
  height: 26px;
  line-height: 26px;
  text-align: left;
  font-size: 14px;
  display: block;
  flex: none;
  color: #666;
}

.add_instr_box .form_top .form_top_left ul li input[type="text"] {
  flex: 1;
  height: 26px;
  font-size: 14px;
  padding: 0 8px;
}

.add_instr_box .form_top .form_top_left .el-select {
  flex: 1;
  height: 26px;
  font-size: 14px;
}

.add_instr_box .form_top .form_top_left ul li .el-checkbox {
  margin-right: 15px;
}

.add_instr_box .form_top .form_top_right {
  width: 175px;
  height: 102px;
}

.add_instr_box .form_center {
  width: 100%;
  padding: 10px 35px;
  border: 1px solid #DBDADA;
  border-left: 0;
  border-right: 0;
  display: flex;
  justify-content: space-between;
}

.add_instr_box .form_center span {
  line-height: 20px;
  font-size: 14px;
  color: #666;
  display: block;
}

.add_instr_box .form_tcp_bottom {
  width: 100%;
  padding: 10px 35px;
  border-bottom: 1px solid #DBDADA;
  box-sizing: border-box;
}

.add_instr_box .form_tcp_bottom h5 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.add_instr_box .form_tcp_bottom .dkh {
  width: 280px;
  display: flex;
}

.add_instr_box .form_tcp_bottom .dkh span.bt {
  width: 64px;
  height: 26px;
  line-height: 26px;
  text-align: left;
  font-size: 14px;
  display: block;
  flex: none;
  color: #666;
}

.add_instr_box .form_tcp_bottom .dkh input[type="text"] {
  flex: 1;
  height: 26px;
  font-size: 14px;
  padding: 0 8px;
}

.add_instr_box .form_tcp_bottom ul li {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 10px;
  padding-right: 30px;
  box-sizing: border-box;
}

.add_instr_box .form_tcp_bottom ul li:nth-of-type(1) {
  margin-bottom: 0;
}

.add_instr_box .form_tcp_bottom ul li .zlm {
  width: 25%;
}

.add_instr_box .form_tcp_bottom ul li .zlnr {
  width: 72%;
}

.add_instr_box .form_tcp_bottom ul li span {
  line-height: 26px;
  text-align: left;
  font-size: 14px;
  display: block;
  color: #666;
  margin: 6px 0 3px;
}

.add_instr_box .form_tcp_bottom ul li input[type="text"] {
  height: 26px;
  font-size: 14px;
  width: 100%;
  padding: 0 8px;
}

.add_instr_box .form_tcp_bottom ul li i {
  position: absolute;
  right: 0;
  top: 6px;
}

.add_instr_box .add_zhiling {
  width: 100%;
  margin-top: 5px;
}

.add_instr_box .add_zhiling span {
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  background: #1783FF;
  display: inline-block;
  margin-right: 10px;
  width: 85px;
  height: 26px;
  line-height: 26px;
  border-radius: 3px;
  text-align: center;
}

.add_instr_box .form_tcp_bottom .ck_ul {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.add_instr_box .form_tcp_bottom .ck_ul .ck_list {
  width: 24%;
  display: flex;
  justify-content: space-between;
}

.add_instr_box .form_tcp_bottom .ck_ul .ck_list span.bt {
  line-height: 26px;
  text-align: left;
  font-size: 14px;
  display: block;
  color: #666;
  width: 45px;
  flex: none;
}

.add_instr_box .form_tcp_bottom .ck_ul .ck_list input[type="text"] {
  height: 26px;
  font-size: 14px;
  width: 100%;
  flex: 1;
  padding: 0 8px;
}

.add_instr_box .form_tcp_bottom .ck_ul .el-input__icon {
  width: 10px;
}

.add_instr_box .ck_str {
  text-align: left;
  margin: 5px 0;
}

.add_instr_box .ck_str .el-radio {
  margin-right: 15px;
}

.add_instr_box .ck_str .el-radio:last-child {
  margin-right: 0;
}

.add_instr_box .el-select .el-input .el-select__caret {
  line-height: 26px;
}

// 详情
.detail_instr_box {
  width: ;
  font-size: 14px;
}

.detail_instr_box .el-dialog__body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  height: 600px;
  overflow-y: scroll;
}

.detail_instr_box .form_top {
  width: 100%;
  display: flex;
  padding: 10px 35px;
  box-sizing: border-box;
  justify-content: space-between;
}

.detail_instr_box .form_top .form_top_left {
  width: 280px;
}

.detail_instr_box .form_top .form_top_left ul li {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  line-height: 26px;
}

.detail_instr_box .form_top .form_top_left ul li span.bt {
  width: 64px;
  height: 26px;
  line-height: 26px;
  text-align: left;
  font-size: 14px;
  display: block;
  flex: none;
  color: #666;
}

.detail_instr_box .form_top .form_top_left ul li p {
  flex: 1;
  height: 26px;
  font-size: 14px;
  color: #979797;
}

.detail_instr_box .form_top .form_top_right {
  width: 175px;
  height: 102px;
  border: 1px solid #409EFF;
  box-sizing: border-box;
  border-radius: 5px;
  overflow: hidden;
}

.detail_instr_box .form_center {
  width: 100%;
  padding: 10px 35px;
  border: 1px solid #DBDADA;
  border-left: 0;
  border-right: 0;
  display: flex;
  justify-content: space-between;
}

.detail_instr_box .form_center p {
  line-height: 20px;
  font-size: 16px;
  color: #666;
  display: block;
  font-weight: bold;
}

.detail_instr_box .form_bottom {
  width: 100%;
}

.detail_instr_box .form_bottom ul li {
  width: 100%;
  padding: 10px 35px;
  border-bottom: 1px solid #DBDADA;
  box-sizing: border-box;
}

.detail_instr_box .form_bottom ul li h4 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.detail_instr_box .form_bottom ul li .top {
  width: 100%;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}

.detail_instr_box .form_bottom ul li .top div {
  width: 24%;
  display: flex;
  justify-content: space-between;
}

.detail_instr_box .form_bottom ul li .top div span {
  width: 60px;
}

.detail_instr_box .form_bottom ul li .top span {
  width: 80px;
  flex: none;
}

.detail_instr_box .form_bottom ul li .top p {
  width: 100%;
  flex: 1;
  color: #979797;
}

.detail_instr_box .form_bottom ul li .bottom {
  margin-top: 5px;
}

.detail_instr_box .form_bottom ul li .bottom h4 {
  color: #666;
  font-size: 14px;
  font-weight: normal;
  margin-top: 8px;
  margin-bottom: 0;
}

.detail_instr_box .form_bottom ul li .bottom p {
  line-height: 20px;
  margin: 5px 0;
  width: 48%;
  margin-right: 2%;
  height: 20px;
  overflow: hidden;
  display: inline-block;
  color: #979797;
  padding-left: 14px;
  box-sizing: border-box;
  position: relative;
}

.detail_instr_box .form_bottom ul li .bottom p::before {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  left: 0;
  top: 6px;
  content: ' ';
  background: #979797;
  position: absolute;
}

// 内容补充
.append_instr_box .el-dialog__body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  height: 500px;
  overflow-y: scroll;
}

.append_instr_box .append_top {
  padding: 10px 35px;
  border-bottom: 1px solid #DBDADA;
  box-sizing: border-box;
}

.append_instr_box .append_top p {
  line-height: 24px;
}

.append_instr_box .append_top .el-checkbox-group {
  margin: 5px 0;
}

.append_instr_box .append_top .el-checkbox {
  margin-right: 15px;
}

// 反馈
.fankui_instr_box {
}

.fankui_instr_box .el-dialog__body {
  padding-top: 0;
  padding-left: 35px;
  padding-right: 35px;
  max-height: 600px;
}

.fankui_instr_box h4 {
  margin: 10px 0;
}

.fankui_instr_box textarea {
  height: 200px;
  font-family: "微软雅黑";
}

// 页码栏样式
.page {
  width: 1300px;
  margin: 30px auto;
  text-align: center;

  .el-pagination .btn-next .el-icon,
  .el-pagination .btn-prev .el-icon {
    font-size: 18px;
  }

  .el-pager li {
    font-size: 18px;
    margin-right: 20px;
    border-radius: 5px;
    font-weight: 400;
  }

  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    font-size: 18px;
  }

  .el-pagination__editor.el-input .el-input__inner {
    font-size: 18px;
  }

  .el-icon-arrow-right:before {
    content: "下一页";
    font-weight: 400;
  }

  .el-pager li.active {
    background-color: #409eff;
    color: #fff;
  }
}

.avatar-uploader .el-upload {
  border: 1px solid #409EFF;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 175px;
  height: 102px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 32px;
  line-height: 52px;
  text-align: center;
  color: #1783FF;
}

.avatar-uploader div {
  text-align: center;
}

.avatar-uploader div span {
  font-size: 16px;
  color: #000;
  margin-top: 10px;
  display: block;
}

.avatar-uploader div p {
  font-size: 12px;
  color: #000;
}

.avatar {
  width: 175px;
  height: 102px;
  display: block;
  object-fit: cover;
}

.video_none {
  text-align: center;
  padding: 60px;
}

[v-cloak] {
  display: none;
}
</style>
